import Vue from "vue";
import Router from "vue-router";
import Blank from "./views/layout/blank";
import Layout from "./views/layout";
import Login from "@/views/Login.vue";
import { ADMIN_SCOPE } from "./permission/const";

const routerPush = Router.prototype.push;
Router.prototype.push = function push(location) {
  return routerPush.call(this, location).catch(error => error);
};
Vue.use(Router);
export const constantRoutes = [
  {
    path: "/login",
    component: Login,
  },
  {
    path: "/404",
    component: () => import("./views/NotFound"),
  },
  {
    path: "/unauthorized",
    component: () => import("./views/Unauthorized"),
  },
  {
    path: "/stores",
    meta: {},
    component: () => import("./views/stores/index"),
  },
  {
    path: "/questionnaire",
    meta: {},
    component: () => import("./views/stores/questionnaire"),
  },
];
export const asyncRoutes = [
  {
    path: "/",
    component: Layout,
    redirect: "/index",
    meta: {},
    children: [
      {
        path: "index",
        component: () => import("./views/homepage"),
        name: "首页",
        hidden: true,
        meta: {},
      },
      {
        path: "activity",
        component: Blank,
        name: "线下活动",
        redirect: "/activity/ua",
        meta: {
          roles: [ADMIN_SCOPE],
          icon: "activity",
        },
        children: [
          {
            path: "ua",
            component: () => import("./views/activity/uaStar/index"),
            icon: "user",
            name: "UA STAR",
            meta: {
              roles: [ADMIN_SCOPE],
              title: "UA STAR活动列表",
              keepAlive: true,
            },
          },
          {
            path: "ua/edit",
            component: () => import("./views/activity/uaStar/edit/index"),
            name: "编辑",
            hidden: true,
            meta: {
              roles: [ADMIN_SCOPE],
              activeMenu: "/activity/ua",
              propName: "UA STAR",
            },
          },
          {
            path: "ua/add",
            component: () => import("./views/activity/uaStar/edit/index"),
            name: "新增",
            hidden: true,
            meta: {
              roles: [ADMIN_SCOPE],
              activeMenu: "/activity/ua",
              propName: "UA STAR",
            },
          },
          {
            path: "letsBasketball",
            component: () => import("./views/activity/letsBasketball/index"),
            icon: "",
            name: "LET’S3 三人篮球",
            meta: {
              roles: [ADMIN_SCOPE],
            },
          },
          {
            path: "letsBasketball/add",
            component: () => import("./views/activity/letsBasketball/edit/index"),
            name: "新增",
            hidden: true,
            meta: {
              roles: [ADMIN_SCOPE],
              activeMenu: "/activity/letsBasketball",
              propName: "LET’S3 三人篮球",
            },
          },
          {
            path: "letsBasketball/edit",
            component: () => import("./views/activity/letsBasketball/edit/index"),
            name: "编辑",
            hidden: true,
            meta: {
              roles: [ADMIN_SCOPE],
              activeMenu: "/activity/letsBasketball",
              propName: "LET’S3 三人篮球",
            },
          },
          {
            path: "letsBasketball/photo-album-upload",
            component: () => import("./views/activity/letsBasketball/photoUpload/index"),
            name: "上传活动相册",
            hidden: true,
            meta: {
              roles: [ADMIN_SCOPE],
              activeMenu: "/activity/letsBasketball",
              propName: "LET’S3 三人篮球",
            },
          },
          {
            path: "uara",
            component: () => import("./views/activity/uara/index"),
            icon: "",
            name: "UARA 路跑学院",
            meta: {
              roles: [ADMIN_SCOPE],
            },
          },
          {
            path: "uara/add",
            component: () => import("./views/activity/uara/add/index"),
            name: "新增",
            hidden: true,
            meta: {
              roles: [ADMIN_SCOPE],
              activeMenu: "/activity/uara",
              propName: "UARA 路跑学院",
            },
          },
          {
            path: "uara/edit",
            component: () => import("./views/activity/uara/add/index"),
            name: "编辑",
            hidden: true,
            meta: {
              roles: [ADMIN_SCOPE],
              activeMenu: "/activity/uara",
              propName: "UARA 路跑学院",
            },
          },
          {
            path: "uara/photo-album-upload",
            component: () => import("./views/activity/uara/photoUpload/index"),
            name: "上传活动相册",
            hidden: true,
            meta: {
              roles: [ADMIN_SCOPE],
              activeMenu: "/activity/uara",
              propName: "UARA 路跑学院",
            },
          },
          {
            path: "activityAggregationPage",
            component: () => import("./views/activity/aggregation/index"),
            icon: "user",
            name: "把汗流漂亮",
            meta: {
              roles: [ADMIN_SCOPE],
            },
          },
          {
            path: "activityAggregationPage/add",
            component: () => import("./views/activity/aggregation/edit/index"),
            name: "新增",
            hidden: true,
            meta: {
              roles: [ADMIN_SCOPE],
              activeMenu: "/activity/activityAggregationPage",
              propName: "把汗流漂亮",
            },
          },
          {
            path: "activityAggregationPage/edit",
            component: () => import("./views/activity/aggregation/edit/index"),
            name: "编辑",
            hidden: true,
            meta: {
              roles: [ADMIN_SCOPE],
              activeMenu: "/activity/activityAggregationPage",
              propName: "把汗流漂亮",
            },
          },
          {
            path: "topic",
            component: () => import("./views/activity/topic/index"),
            icon: "store",
            name: "UA 专题活动",
            meta: {
              roles: [ADMIN_SCOPE],
            },
          },
          {
            path: "topic/edit",
            component: () => import("./views/activity/topic/edit/index"),
            name: "编辑",
            hidden: true,
            meta: {
              roles: [ADMIN_SCOPE],
              activeMenu: "/activity/topic",
              propName: "UA 专题活动",
            },
          },
          {
            path: "topic/add",
            component: () => import("./views/activity/topic/edit/index"),
            name: "新增",
            hidden: true,
            meta: {
              roles: [ADMIN_SCOPE],
              activeMenu: "/activity/topic",
              propName: "UA 专题活动",
            },
          },
          {
            path: "photo",
            component: () => import("./views/activity/photoUpload/index"),
            icon: "store",
            name: "活动照片/视频",
            meta: {
              roles: [ADMIN_SCOPE],
            },
          },
          {
            path: "photo/edit",
            component: () => import("./views/activity/photoUpload/edit/index"),
            name: "编辑",
            hidden: true,
            meta: {
              roles: [ADMIN_SCOPE],
              activeMenu: "/activity/photo",
              propName: "活动照片/视频",
            },
          },
          {
            path: "photo_of_special/add",
            component: () => import("./views/activity/photoUpload/special/index"),
            name: "新增相册",
            hidden: true,
            meta: {
              roles: [ADMIN_SCOPE],
              activeMenu: "/activity/photo",
              propName: "活动照片/视频",
            },
          },
          {
            path: "photo_of_special/edit",
            component: () => import("./views/activity/photoUpload/special/index"),
            name: "编辑相册",
            hidden: true,
            meta: {
              roles: [ADMIN_SCOPE],
              activeMenu: "/activity/photo",
              propName: "活动照片/视频",
            },
          },

        ],
      },
      {
        path: "online_activity",
        component: Blank,
        name: "线上活动",
        redirect: "/online_activity/taskClock",
        meta: {
          roles: [ADMIN_SCOPE],
          icon: "online_activity",
        },
        children: [
          {
            path: "taskClock",
            component: () => import("./views/online_activity/taskClock/index"),
            name: '打卡活动',
            meta: {
              roles: [ADMIN_SCOPE],
              title: "打卡活动列表",
            },
          },
          {
            path: "taskClock/add",
            component: () => import("./views/online_activity/taskClock/edit/index"),
            name: "新增",
            hidden: true,
            meta: {
              roles: [ADMIN_SCOPE],
              activeMenu: "/online_activity/taskClock",
              propName: "打卡活动",
            },
          },
          {
            path: "taskClock/edit",
            component: () => import("./views/online_activity/taskClock/edit/index"),
            name: "编辑",
            hidden: true,
            meta: {
              roles: [ADMIN_SCOPE],
              activeMenu: "/online_activity/taskClock",
              propName: "打卡活动",
            },
          },
          /* {
            path: "challengeMatch",
            component: () => import("./views/online_activity/challenge-match/index"),
            icon: "",
            name: "挑战赛",
            meta: {
              roles: [ADMIN_SCOPE],
              title: "挑战赛列表",
            },
          }, */
          {
            path: "challengeMatch/add",
            component: () => import("./views/online_activity/challenge-match/edit/index"),
            name: "新增",
            hidden: true,
            meta: {
              roles: [ADMIN_SCOPE],
              activeMenu: "/online_activity/challengeMatch",
              propName: "挑战赛",
            },
          },
          {
            path: "challengeMatch/edit",
            component: () => import("./views/online_activity/challenge-match/edit/index"),
            name: "编辑",
            hidden: true,
            meta: {
              roles: [ADMIN_SCOPE],
              activeMenu: "/online_activity/challengeMatch",
              propName: "挑战赛",
            },
          },
          {
            path: "running",
            component: () => import("./views/online_activity/running/index"),
            name: '跑步/骑行活动',
            meta: {
              roles: [ADMIN_SCOPE],
              title: "跑步/骑行活动",
            },
          },
          {
            path: "running/add",
            component: () => import("./views/online_activity/running/add/index"),
            name: "新增",
            hidden: true,
            meta: {
              roles: [ADMIN_SCOPE],
              activeMenu: "/online_activity/running",
              propName: "跑步/骑行活动",
            },
          },
          {
            path: "running/edit",
            component: () => import("./views/online_activity/running/add/index"),
            name: "编辑",
            hidden: true,
            meta: {
              roles: [ADMIN_SCOPE],
              activeMenu: "/online_activity/running",
              propName: "跑步/骑行活动",
            },
          },
          {
            path: "running/graph",
            component: () => import("./views/online_activity/running/graph/index"),
            name: "查看轨迹图",
            hidden: true,
            meta: {
              roles: [ADMIN_SCOPE],
              activeMenu: "/online_activity/running",
              propName: "跑步/骑行活动",
            },
          },
          {
            path: "camp",
            component: () => import("./views/online_activity/camp/index"),
            icon: "",
            name: "训练营",
            hidden: true,
            meta: {
              roles: [ADMIN_SCOPE],
              activeMenu: "/online_activity/camp",
            },
          },
          {
            path: "camp/edit",
            component: () => import("./views/online_activity/camp/edit/index"),
            name: "编辑",
            hidden: true,
            meta: {
              roles: [ADMIN_SCOPE],
              activeMenu: "/online_activity/camp",
              propName: "训练营",
            },
          },
          {
            path: "camp/add",
            component: () => import("./views/online_activity/camp/edit/index"),
            name: "新增",
            hidden: true,
            meta: {
              roles: [ADMIN_SCOPE],
              activeMenu: "/online_activity/camp",
              propName: "训练营",
            },
          },
          {
            path: "meridianCamp",
            component: () => import("./views/online_activity/meridianCamp/index"),
            name: 'camp配置',
            meta: {
              roles: [ADMIN_SCOPE],
              title: "camp配置",
            },
          },
          {
            path: "meridianCamp/add",
            component: () => import("./views/online_activity/meridianCamp/edit/index"),
            name: '新增',
            hidden: true,
            meta: {
              roles: [ADMIN_SCOPE],
              activeMenu: "/online_activity/meridianCamp",
              propName: "camp配置",
            },
          },
          {
            path: "meridianCamp/edit",
            component: () => import("./views/online_activity/meridianCamp/edit/index"),
            name: '编辑',
            hidden: true,
            meta: {
              roles: [ADMIN_SCOPE],
              activeMenu: "/online_activity/meridianCamp",
              propName: "camp配置",
            },
          },
          {
            path: "plan",
            component: () => import("./views/online_activity/plan/index"),
            name: '训练计划配置',
            meta: {
              roles: [ADMIN_SCOPE],
              title: "训练计划列表",
            },
          },
          {
            path: "plan/add",
            component: () => import("./views/online_activity/plan/edit/index"),
            name: '新增',
            hidden: true,
            meta: {
              roles: [ADMIN_SCOPE],
              activeMenu: "/online_activity/plan",
              propName: "训练计划列表",
            },
          },
          {
            path: "plan/edit",
            component: () => import("./views/online_activity/plan/edit/index"),
            name: '编辑',
            hidden: true,
            meta: {
              roles: [ADMIN_SCOPE],
              activeMenu: "/online_activity/plan",
              propName: "训练计划列表",
            },
          },
        ],
      },
      {
        path: "rugby",
        component: Blank,
        name: "腰旗橄榄球",
        redirect: "/rugby/list",
        meta: {
          roles: [ADMIN_SCOPE],
          icon: "rugby",
        },
        children: [
          {
            path: "list",
            component: () => import("./views/rugby/list/index"),
            icon: "",
            name: "俱乐部列表",
            meta: {
              roles: [ADMIN_SCOPE],
              title: "俱乐部列表",
              keepAlive: true,
            },
          },
          {
            path: "list/look",
            component: () => import("./views/rugby/list/look/index"),
            name: "查看",
            hidden: true,
            meta: {
              roles: [ADMIN_SCOPE],
              activeMenu: "/rugby/list",
              propName: "俱乐部列表",
            },
          },
          {
            path: "list/edit",
            component: () => import("./views/rugby/list/edit/index"),
            name: "编辑",
            hidden: true,
            meta: {
              roles: [ADMIN_SCOPE],
              activeMenu: "/rugby/list",
              propName: "俱乐部列表",
            },
          },
          {
            path: "list/add",
            component: () => import("./views/rugby/list/edit/index"),
            name: "新增",
            hidden: true,
            meta: {
              roles: [ADMIN_SCOPE],
              activeMenu: "/rugby/list",
              propName: "俱乐部列表",
            },
          },
          {
            path: "activity",
            component: () => import("./views/rugby/activity/index"),
            icon: "",
            name: "俱乐部活动",
            meta: {
              roles: [ADMIN_SCOPE],
            },
          },
          {
            path: "activity/edit",
            component: () => import("./views/rugby/activity/edit/index"),
            name: "查看",
            hidden: true,
            meta: {
              roles: [ADMIN_SCOPE],
              activeMenu: "/rugby/activity",
              propName: "俱乐部活动",
            },
          },
          {
            path: "review",
            component: () => import("./views/rugby/review/index"),
            icon: "",
            name: "俱乐部Leader审批",
            meta: {
              roles: [ADMIN_SCOPE],
            },
          },
          {
            path: "review/edit",
            component: () => import("./views/rugby/review/edit/index"),
            name: "查看",
            hidden: true,
            meta: {
              roles: [ADMIN_SCOPE],
              activeMenu: "/rugby/review",
              propName: "俱乐部Leader审批",
            },
          },
          {
            path: "activityImgSetting",
            component: () => import("./views/rugby/activityImgSetting/index"),
            icon: "",
            name: "俱乐部活动图片配置",
            meta: {
              roles: [ADMIN_SCOPE],
            },
          },
          {
            path: "officialEvent",
            component: () => import("./views/rugby/officialEvent/index"),
            icon: "",
            name: "官方赛事",
            meta: {
              roles: [ADMIN_SCOPE],
            },
          },
          {
            path: "officialEvent/add",
            component: () => import("./views/rugby/officialEvent/edit/index"),
            name: "新增",
            hidden: true,
            meta: {
              roles: [ADMIN_SCOPE],
              activeMenu: "/rugby/officialEvent",
              propName: "官方赛事",
            },
          },
          {
            path: "officialEvent/edit",
            component: () => import("./views/rugby/officialEvent/edit/index"),
            name: "编辑",
            hidden: true,
            meta: {
              roles: [ADMIN_SCOPE],
              activeMenu: "/rugby/officialEvent",
              propName: "官方赛事",
            },
          },
        ],
      },
      {
        path: "class",
        component: Blank,
        name: "视频课程",
        redirect: "/class/index",
        meta: {
          roles: [ADMIN_SCOPE],
          icon: "class",
        },
        children: [
          {
            path: "index",
            component: () => import("./views/class/index"),
            icon: "",
            name: "课程列表",
            hidden: true,
            meta: {
              roles: [ADMIN_SCOPE],
              activeMenu: "/class",
              keepAlive: true,
            },
          },
          {
            path: "edit",
            component: () => import("./views/class/edit/index"),
            name: "编辑",
            hidden: true,
            meta: {
              roles: [ADMIN_SCOPE],
              activeMenu: "/class",
              propName: "课程列表",
            },
          },
          {
            path: "add",
            component: () => import("./views/class/edit/index"),
            name: "新增",
            hidden: true,
            meta: {
              roles: [ADMIN_SCOPE],
              activeMenu: "/class",
              propName: "课程列表",
            },
          },
        ],
      },
      {
        path: "curriculumCollectionManagement",
        component: Blank,
        name: "课程集合管理",
        redirect: "/curriculumCollectionManagement/index",
        meta: {
          roles: [ADMIN_SCOPE],
          icon: "curriculumCollectionManagement",
        },
        children: [
          {
            path: "index",
            component: () => import("./views/curriculumCollectionManagement/index"),
            icon: "",
            name: "课程集合页列表",
            hidden: true,
            meta: {
              roles: [ADMIN_SCOPE],
              activeMenu: "/curriculumCollectionManagement",
            },
          },
          {
            path: "edit",
            component: () => import("./views/curriculumCollectionManagement/edit/index"),
            name: "编辑",
            hidden: true,
            meta: {
              roles: [ADMIN_SCOPE],
              activeMenu: "/curriculumCollectionManagement",
              propName: "课程集合页列表",
            },
          },
          {
            path: "add",
            component: () => import("./views/curriculumCollectionManagement/edit/index"),
            name: "新增",
            hidden: true,
            meta: {
              roles: [ADMIN_SCOPE],
              activeMenu: "/curriculumCollectionManagement",
              propName: "课程集合页列表",
            },
          },
        ],
      },
      {
        path: "coach",
        component: Blank,
        name: "教练管理",
        redirect: "/coach/information",
        meta: {
          roles: [ADMIN_SCOPE],
          icon: "coach",
        },
        children: [
          {
            path: "information",
            component: () => import("./views/coach/information/index"),
            name: "教练信息",
            meta: {
              roles: [ADMIN_SCOPE],
              title: "教练信息列表",
            },
          },
          {
            path: "information/edit",
            component: () => import("./views/coach/information/edit/index"),
            name: "编辑",
            hidden: true,
            meta: {
              roles: [ADMIN_SCOPE],
              activeMenu: "/coach/information",
              propName: "教练信息列表",
            },
          },
          {
            path: "duration",
            component: () => import("./views/coach/duration/index"),
            name: "任务时长",
            meta: {
              roles: [ADMIN_SCOPE],
              title: "",
            },
          },
          {
            path: "duration/edit",
            component: () => import("./views/coach/duration/edit/index"),
            name: "编辑",
            hidden: true,
            meta: {
              roles: [ADMIN_SCOPE],
              activeMenu: "/coach/duration",
              propName: "任务时长",
            },
          },
          {
            path: "coupon",
            component: () => import("./views/coach/coupon/index"),
            name: "教练券",
            meta: {
              roles: [ADMIN_SCOPE],
            },
          },
        ],
      },
      {
        path: "AIOminiApp-config",
        component: Blank,
        name: "小程序配置",
        meta: {
          roles: [ADMIN_SCOPE],
          icon: "AIOconfig",
        },
        children: [
          {
            path: "channelPage",
            component: () => import("./views/AIOminiApp-config/channelPage/index"),
            icon: "",
            name: "频道页面内容配置",
            meta: {
              roles: [ADMIN_SCOPE],
            },
          },
          {
            path: "AIpopup",
            component: () => import("./views/AIOminiApp-config/popup/index"),
            icon: "",
            name: "页面弹窗配置",
            meta: {
              roles: [ADMIN_SCOPE],
              title: "首页弹窗列表",
            },
          },
          {
            path: "AIpopup/edit",
            component: () => import("./views/AIOminiApp-config/popup/edit/index"),
            name: "编辑",
            hidden: true,
            meta: {
              roles: [ADMIN_SCOPE],
              activeMenu: "/AIOminiApp-config/AIpopup",
              propName: "首页弹窗配置",
            },
          },
          {
            path: "AIpopup/add",
            component: () => import("./views/AIOminiApp-config/popup/edit/index"),
            name: "新增",
            hidden: true,
            meta: {
              roles: [ADMIN_SCOPE],
              activeMenu: "/AIOminiApp-config/AIpopup",
              propName: "首页弹窗配置",
            },
          },
          {
            path: "homeModuleConfig",
            component: () => import("./views/AIOminiApp-config/homeModuleConfig/index"),
            name: '首页功能模块配置',
            meta: {
              roles: [ADMIN_SCOPE],
              title: "首页功能模块配置",
            },
          },
          {
            path: "quickFilterConfiguration",
            component: () => import("./views/AIOminiApp-config/quickFilterConfiguration/index"),
            icon: "",
            name: "快速筛选配置",
            meta: {
              roles: [ADMIN_SCOPE],
            },
          },
          {
            path: "activePageConfiguration",
            component: () => import("./views/AIOminiApp-config/activity/index"),
            icon: '',
            name: "活动页面配置",
            meta: {
              roles: [ADMIN_SCOPE],
            },
          },
          {
            path: "activePageConfiguration/add",
            component: () => import("./views/AIOminiApp-config/activity/handle/index"),
            icon: '',
            name: "新增",
            hidden: true,
            meta: {
              roles: [ADMIN_SCOPE],
              activeMenu: "/AIOminiApp-config/activePageConfiguration",
              propName: "活动页面配置",
            },
          },
          {
            path: "activePageConfiguration/edit",
            component: () => import("./views/AIOminiApp-config/activity/handle/index"),
            icon: '',
            name: "编辑",
            hidden: true,
            meta: {
              roles: [ADMIN_SCOPE],
              activeMenu: "/AIOminiApp-config/activePageConfiguration",
              propName: "活动页面配置",
            },
          },
          {
            path: "AIbanner",
            component: () => import("./views/AIOminiApp-config/banner/index"),
            icon: "",
            name: "首页banner配置",
            hidden: true,
            meta: {
              roles: [ADMIN_SCOPE],
            },
          },
          {
            path: "AIclass",
            component: () =>
              import("./views/AIOminiApp-config/class-recommend/index"),
            icon: "",
            name: "首页课程推荐配置",
            hidden: true,
            meta: {
              roles: [ADMIN_SCOPE],
            },
          },
        ],
      },
      {
        path: "ecAdvertecAdvert",
        component: Blank,
        name: "EC 广告配置",
        redirect: "/ecAdvertecAdvert/banner",
        meta: {
          roles: [ADMIN_SCOPE],
          icon: "ec",
        },
        children: [
          {
            path: "banner",
            component: () => import("./views/ecAdvertecAdvert/banner/index"),
            name: "EC banner广告",
            hidden: true,
            meta: {
              roles: [ADMIN_SCOPE],
              title: "EC Banner广告",
              activeMenu: "/ecAdvertecAdvert",
            },
          },
          {
            path: "productRecommendation",
            component: () => import("./views/ecAdvertecAdvert/productRecommendation/index"),
            name: "EC 商品推荐",
            hidden: true,
            meta: {
              roles: [ADMIN_SCOPE],
              title: "EC 商品推荐",
            },
          },
        ],
      },
      {
        path: "nextCombine",
        component: Blank,
        name: "Next Combine",
        redirect: "/nextCombine/mainActivity",
        meta: {
          roles: [ADMIN_SCOPE],
          icon: "combine",
        },
        children: [
          {
            path: "mainActivity",
            component: () => import("./views/nextCombine/mainActivity/index"),
            name: "主活动列表",
            meta: {
              roles: [ADMIN_SCOPE],
              title: "主活动列表页",
              keepAlive: true,
            },
          },
          {
            path: "mainActivity/edit",
            component: () => import("./views/nextCombine/mainActivity/edit/index"),
            name: "编辑",
            hidden: true,
            meta: {
              roles: [ADMIN_SCOPE],
              activeMenu: "/nextCombine/mainActivity",
              propName: "Next Combine",
            },
          },
          {
            path: "mainActivity/add",
            component: () => import("./views/nextCombine/mainActivity/edit/index"),
            name: "新增",
            hidden: true,
            meta: {
              roles: [ADMIN_SCOPE],
              activeMenu: "/nextCombine/mainActivity",
              propName: "Next Combine",
            },
          },
          {
            path: "subActivity",
            component: () => import("./views/nextCombine/subActivity/index"),
            name: "子活动列表",
            meta: {
              roles: [ADMIN_SCOPE],
              title: "子活动列表页",
              keepAlive: true,
            },
          },
          {
            path: "subActivity/edit",
            component: () => import("./views/nextCombine/subActivity/edit/index"),
            name: "编辑",
            hidden: true,
            meta: {
              roles: [ADMIN_SCOPE],
              activeMenu: "/nextCombine/subActivity",
              propName: "Next Combine",
            },
          },
          {
            path: "subActivity/add",
            component: () => import("./views/nextCombine/subActivity/edit/index"),
            name: "新增",
            hidden: true,
            meta: {
              roles: [ADMIN_SCOPE],
              activeMenu: "/nextCombine/subActivity",
              propName: "Next Combine",
            },
          },
          {
            path: "hhrgift",
            component: () => import("./views/nextCombine/hhrgift/index"),
            name: "HHR 礼品登记信息",
            meta: {
              roles: [ADMIN_SCOPE],
              title: "HHR 礼品登记信息",
              keepAlive: true,
            },
          },
        ],
      },
      {
        path: "member",
        component: Blank,
        name: "会员",
        redirect: "/member/medal/index",
        meta: {
          roles: [ADMIN_SCOPE],
          icon: "member",
        },
        children: [
          {
            path: "medal/index",
            component: () => import("./views/member/medal/index"),
            icon: "",
            name: "会员徽章管理",
            meta: {
              roles: [ADMIN_SCOPE],
              propName: '会员',
            },
          },
          {
            path: "benefits",
            component: () => import("./views/member/benefits/index"),
            icon: "",
            name: "会员权益配置",
            meta: {
              roles: [ADMIN_SCOPE],
              propName: '会员',
            },
          },
          {
            path: "newProductPriority/add",
            component: () => import("./views/member/newProductPriority/edit/index"),
            icon: "",
            hidden: true,
            name: "新增新品优先权",
            meta: {
              roles: [ADMIN_SCOPE],
              propName: '会员权益配置',
              activeMenu: '/member/benefits',
            },
          },
          {
            path: "newProductPriority/edit",
            component: () => import("./views/member/newProductPriority/edit/index"),
            icon: "",
            hidden: true,
            name: "权益详情  ",
            meta: {
              roles: [ADMIN_SCOPE],
              propName: '会员权益配置',
              activeMenu: '/member/benefits',
            },
          },
          {
            path: "limitedPackaging/edit",
            component: () => import("./views/member/limitedPackaging/edit/index"),
            icon: "",
            hidden: true,
            name: "会员权益配置",
            meta: {
              roles: [ADMIN_SCOPE],
              propName: '会员',
              activeMenu: '/member/benefits',
            },
          },
          {
            path: "freeShoeCleaningCoupon/edit",
            component: () => import("./views/member/freeShoeCleaningCoupon/edit/index"),
            icon: "",
            hidden: true,
            name: "会员权益配置",
            meta: {
              roles: [ADMIN_SCOPE],
              propName: '会员',
              activeMenu: '/member/benefits',
            },
          },
          {
            path: "sportsExperienceVoucher/edit",
            component: () => import("./views/member/sportsExperienceVoucher/edit/index"),
            icon: "",
            hidden: true,
            name: "会员权益配置",
            meta: {
              roles: [ADMIN_SCOPE],
              propName: '会员',
              activeMenu: '/member/benefits',
            },
          },
          {
            path: "promotionPriority/index",
            component: () => import("./views/member/promotionPriority/index"),
            icon: "",
            hidden: true,
            name: "会员权益配置",
            meta: {
              roles: [ADMIN_SCOPE],
              propName: '会员',
              activeMenu: '/member/benefits',
            },
          },
          {
            path: "promotionPriority/edit",
            component: () => import("./views/member/promotionPriority/edit/index"),
            icon: "",
            hidden: true,
            name: "会员权益配置",
            meta: {
              roles: [ADMIN_SCOPE],
              propName: '会员',
              activeMenu: '/member/benefits',
            },
          },
          {
            path: "promotionPriority/add",
            component: () => import("./views/member/promotionPriority/edit/index"),
            icon: "",
            hidden: true,
            name: "新增促销优先权",
            meta: {
              roles: [ADMIN_SCOPE],
              propName: '会员权益配置',
              activeMenu: '/member/benefits',
            },
          },
          {
            path: "activityExclusivePreferential/index",
            component: () => import("./views/member/activityExclusivePreferential/index"),
            icon: "",
            hidden: true,
            name: "会员权益配置",
            meta: {
              roles: [ADMIN_SCOPE],
              propName: '会员',
              activeMenu: '/member/benefits',
            },
          },
          {
            path: "activityExclusivePreferential/edit",
            component: () => import("./views/member/activityExclusivePreferential/edit/index"),
            icon: "",
            hidden: true,
            name: "会员权益配置",
            meta: {
              roles: [ADMIN_SCOPE],
              propName: '会员',
              activeMenu: '/member/benefits',
            },
          },
          {
            path: "activityExclusivePreferential/add",
            component: () => import("./views/member/activityExclusivePreferential/edit/index"),
            icon: "",
            hidden: true,
            name: "新增活动专属优惠",
            meta: {
              roles: [ADMIN_SCOPE],
              propName: '会员权益配置',
              activeMenu: '/member/benefits',
            },
          },
          {
            path: "brandEventInvitation/index",
            component: () => import("./views/member/brandEventInvitation/index"),
            icon: "",
            hidden: true,
            name: "会员权益配置",
            meta: {
              roles: [ADMIN_SCOPE],
              propName: '会员',
              activeMenu: '/member/benefits',
            },
          },
          {
            path: "brandEventInvitation/edit",
            component: () => import("./views/member/brandEventInvitation/edit/index"),
            icon: "",
            hidden: true,
            name: "会员权益配置",
            meta: {
              roles: [ADMIN_SCOPE],
              propName: '会员',
              activeMenu: '/member/benefits',
            },
          },
          {
            path: "brandEventInvitation/add",
            component: () => import("./views/member/brandEventInvitation/edit/index"),
            icon: "",
            hidden: true,
            name: "新增品牌活动邀请",
            meta: {
              roles: [ADMIN_SCOPE],
              propName: '会员权益配置',
              activeMenu: '/member/benefits',
            },
          },
          {
            path: "anniversaryCeremony/edit",
            component: () => import("./views/member/anniversaryCeremony/edit/index"),
            icon: "",
            hidden: true,
            name: "会员权益配置",
            meta: {
              roles: [ADMIN_SCOPE],
              propName: '会员',
              activeMenu: '/member/benefits',
            },
          },
        ],
      },
      {
        path: "equipment",
        component: Blank,
        name: "商品管理",
        meta: {
          roles: [ADMIN_SCOPE],
          icon: "goods",
        },
        children: [
          {
            path: "center",
            component: () => import("./views/equipment/center/index"),
            icon: "",
            name: "商品中心",
            meta: {
              roles: [ADMIN_SCOPE],
              title: "商品列表",
            },
          },
          {
            path: "seriesOfClass",
            component: () => import("./views/equipment/seriesOfClass/index"),
            icon: "",
            name: "系列课程商品管理",
            meta: {
              roles: [ADMIN_SCOPE],
            },
          },
          {
            path: "seriesOfClass/edit",
            component: () =>
              import("./views/equipment/seriesOfClass/edit/index"),
            name: "管理关联商品",
            hidden: true,
            meta: {
              roles: [ADMIN_SCOPE],
              activeMenu: "/equipment/seriesOfClass",
              propName: "系列课程商品管理",
            },
          },
          {
            path: "taskClock",
            component: () => import("./views/equipment/taskClock/index"),
            icon: "",
            name: "打卡活动商品配置",
            meta: {
              roles: [ADMIN_SCOPE],
            },
          },
          {
            path: "taskClock/edit",
            component: () => import("./views/equipment/taskClock/edit/index"),
            name: "管理关联商品",
            hidden: true,
            meta: {
              roles: [ADMIN_SCOPE],
              activeMenu: "/equipment/taskClock",
              propName: "打卡活动商品配置",
            },
          },
          {
            path: "uara",
            component: () => import("./views/equipment/uara/index"),
            icon: "",
            name: "UARA商品配置",
            meta: {
              roles: [ADMIN_SCOPE],
            },
          },
          {
            path: "letsBasketball",
            component: () => import("./views/equipment/letsBasketball/index"),
            icon: "",
            name: "LETS3商品配置",
            meta: {
              roles: [ADMIN_SCOPE],
            },
          },
          {
            path: "meridianCamp",
            component: () => import("./views/equipment/meridianCamp/index"),
            icon: "",
            name: "CAMP活动商品配置",
            meta: {
              roles: [ADMIN_SCOPE],
            },
          },
          {
            path: "meridianCamp/edit",
            component: () =>
              import("./views/equipment/meridianCamp/edit/index"),
            name: "管理关联商品",
            hidden: true,
            meta: {
              roles: [ADMIN_SCOPE],
              activeMenu: "/equipment/meridianCamp",
              propName: "CAMP商品配置",
            },
          },
          {
            path: "nextCombine",
            component: () => import("./views/equipment/nextCombine/index"),
            icon: "",
            name: "NC商品配置",
            meta: {
              roles: [ADMIN_SCOPE],
            },
          },
          {
            path: "nextCombine/edit",
            component: () =>
              import("./views/equipment/nextCombine/edit/index"),
            name: "管理关联商品",
            hidden: true,
            meta: {
              roles: [ADMIN_SCOPE],
              activeMenu: "/equipment/nextCombine",
              propName: "Combine商品配置",
            },
          },
        ],
      },
      {
        path: "questions",
        component: Blank,
        name: "知识题库",
        redirect: "/questions/index",
        meta: {
          roles: [ADMIN_SCOPE],
          icon: "question",
        },
        children: [
          {
            path: "index",
            component: () => import("./views/questions/index"),
            icon: "",
            name: "知识题库",
            hidden: true,
            meta: {
              roles: [ADMIN_SCOPE],
              activeMenu: "/questions",
            },
          },
        ],
      },
      {
        path: "lottery",
        component: Blank,
        name: "开奖管理",
        redirect: "/lottery/index",
        meta: {
          roles: [ADMIN_SCOPE],
          icon: "lottery",
        },
        children: [
          {
            path: "index",
            component: () => import("./views/lottery/index"),
            icon: "",
            name: "开奖管理",
            // hidden: true,
            meta: {
              roles: [ADMIN_SCOPE],
            },
          },
          {
            path: "edit",
            component: () => import("./views/lottery/edit/index"),
            name: "编辑",
            hidden: true,
            meta: {
              roles: [ADMIN_SCOPE],
              activeMenu: "/lottery/index",
              propName: "开奖管理",
            },
          },
          {
            path: "add",
            component: () => import("./views/lottery/edit/index"),
            name: "新增",
            hidden: true,
            meta: {
              roles: [ADMIN_SCOPE],
              activeMenu: "/lottery/index",
              propName: "开奖管理",
            },
          },
          {
            path: "campLottery",
            component: () => import("./views/lottery/campLottery/index"),
            icon: "",
            name: "抽奖配置",
            meta: {
              roles: [ADMIN_SCOPE],
            },
          },
          {
            path: "campLottery/add",
            component: () => import("./views/lottery/campLottery/edit/index"),
            icon: "",
            name: "新增",
            hidden: true,
            meta: {
              roles: [ADMIN_SCOPE],
              activeMenu: "/lottery/campLottery",
              propName: "抽奖配置",
            },
          },
          {
            path: "campLottery/edit",
            component: () => import("./views/lottery/campLottery/edit/index"),
            icon: "",
            name: "编辑",
            hidden: true,
            meta: {
              roles: [ADMIN_SCOPE],
              activeMenu: "/lottery/campLottery",
              propName: "抽奖配置",
            },
          },
        ],
      },
      {
        path: "store",
        component: Blank,
        name: "店铺管理",
        redirect: "/store/index",
        meta: {
          roles: [ADMIN_SCOPE],
          icon: "store",
        },
        children: [
          {
            path: "index",
            component: () => import("./views/store/index"),
            name: "店铺管理",
            hidden: true,
            meta: {
              roles: [ADMIN_SCOPE],
              activeMenu: "/store",
            },
          },
          {
            path: "edit",
            component: () => import("./views/store/edit/index"),
            name: "编辑",
            hidden: true,
            meta: {
              roles: [ADMIN_SCOPE],
              activeMenu: "/store",
              propName: "店铺列表",
            },
          },
          {
            path: "add",
            component: () => import("./views/store/edit/index"),
            name: "新增",
            hidden: true,
            meta: {
              roles: [ADMIN_SCOPE],
              activeMenu: "/store",
              propName: "店铺列表",
            },
          },
        ],

      },
      {
        path: "voteConfig",
        component: Blank,
        name: "投票管理",
        redirect: "/voteConfig/index",
        meta: {
          roles: [ADMIN_SCOPE],
          icon: "vote",
        },
        children: [
          {
            path: "index",
            component: () => import("./views/voteConfig/index"),
            name: '投票管理',
            hidden: true,
            meta: {
              roles: [ADMIN_SCOPE],
              activeMenu: "/voteConfig",
              title: "投票管理",
            },
          },
          {
            path: "add",
            component: () => import("./views/voteConfig/add/index"),
            name: "新增",
            hidden: true,
            meta: {
              roles: [ADMIN_SCOPE],
              activeMenu: "/voteConfig",
              propName: "投票管理",
            },
          },
          {
            path: "edit",
            component: () => import("./views/voteConfig/add/index"),
            name: "编辑",
            hidden: true,
            meta: {
              roles: [ADMIN_SCOPE],
              activeMenu: "/voteConfig",
              propName: "投票管理",
            },
          },
        ],
      },
      {
        path: "content",
        component: Blank,
        name: "内容管理",
        redirect: "/content/index",
        meta: {
          roles: [ADMIN_SCOPE],
          icon: "content",
        },
        children: [
          {
            path: "index",
            component: () => import("./views/content/index"),
            icon: "",
            name: "内容列表",
            hidden: true,
            meta: {
              roles: [ADMIN_SCOPE],
              activeMenu: "/content",
            },
          },
          {
            path: "edit",
            component: () => import("./views/content/edit/index"),
            name: "编辑",
            hidden: true,
            meta: {
              roles: [ADMIN_SCOPE],
              activeMenu: "/content",
              propName: "内容列表",
            },
          },
          {
            path: "add",
            component: () => import("./views/content/edit/index"),
            name: "新增",
            hidden: true,
            meta: {
              roles: [ADMIN_SCOPE],
              activeMenu: "/content",
              propName: "内容列表",
            },
          },
        ],
      },
      {
        path: "toolbox",
        component: Blank,
        name: "工具箱",
        redirect: "/toolbox/shortLink",
        meta: {
          roles: [ADMIN_SCOPE],
          icon: "toolbox",
        },
        children: [
          {
            path: "shortLink",
            component: () => import("./views/toolbox/shortLink/index"),
            name: '小程序短链',
            meta: {
              roles: [ADMIN_SCOPE],
              title: "小程序短链",
            },
          },
          {
            path: "h5LandingPage",
            component: () => import("./views/toolbox/h5LandingPage/index"),
            name: 'H5落地页配置',
            meta: {
              roles: [ADMIN_SCOPE],
              title: "H5落地页列表",
            },
          },
          {
            path: "h5LandingPage/add",
            component: () => import("./views/toolbox/h5LandingPage/add/index"),
            name: "新增",
            hidden: true,
            meta: {
              roles: [ADMIN_SCOPE],
              activeMenu: "/toolbox/h5LandingPage",
              propName: "H5落地页配置",
            },
          },
        ],
      },
      {
        path: "operation-log",
        component: Blank,
        name: "日志管理",
        redirect: "/operation-log/index",
        meta: {
          roles: [ADMIN_SCOPE],
          icon: "log",
        },
        children: [
          {
            path: "index",
            component: () => import("./views/operation/index"),
            icon: "",
            name: "操作日志",
            hidden: true,
            meta: {
              roles: [ADMIN_SCOPE],
              activeMenu: "/operation-log",
            },
          },
        ],
      },
    ],
  },
];
export default new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: constantRoutes,
});
